"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DeletionConfirmationModal_1 = __importDefault(require("./DeletionConfirmationModal"));
exports.default = DeletionConfirmationModal_1.default;
